module.exports = __webpack_public_path__ + "img/symbol_8.c7546882.png";